require("./supportChatController");

(function () {
  "use strict";

  angular.module("tm.supportChat")
    .directive("tmSupportChatSmall", function() {
      return {
        controller: "supportChatController",
        template: require("./tmSupportChatSmall.html"),
        link,
        restrict: "E"
      };
    });

  function link(scope, element, attrs) {}
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/tm-support-chat/tmSupportChatSmall.directive.js